module.exports = __webpack_public_path__ + "../resources/img/w72_ac_combiner_default.db7599c9.svg";